import { render, staticRenderFns } from "./bar-bottom-mobile.vue?vue&type=template&id=2a9e393d&"
import script from "./bar-bottom-mobile.vue?vue&type=script&lang=js&"
export * from "./bar-bottom-mobile.vue?vue&type=script&lang=js&"
import style0 from "./bar-bottom-mobile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBottomNavigation } from 'vuetify/lib/components/VBottomNavigation';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAvatar,VBottomNavigation,VBtn,VIcon})
